export const BADGE_BG_CSS_VAR = '--custom-badge-bundle-bg';
